import script from "./Content.vue?vue&type=script&setup=true&lang=ts"
export * from "./Content.vue?vue&type=script&setup=true&lang=ts"

import "./Content.vue?vue&type=style&index=0&id=1513d39f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1513d39f"]])

export default __exports__